import React from 'react';

import moment from 'moment';

import useStoreTranslation from 'hooks/useStoreTranslation';

import { Container } from './styles';

interface Props {
  date?: Date;
}

const TripDate = ({ date }: Props) => {
  const { t } = useStoreTranslation();

  return (
    <Container className={!date ? 'undefined-date' : ''}>
      {date ? moment(date).format('ddd[,] DD MMMM') : t('dateRangePicker.date')}
    </Container>
  );
};

export default TripDate;
